import { aanzetCustomClassNames } from "./ClassNames/classNames.aanzet";
import { defaultClassNames } from "./ClassNames/classNames.default";
import { dnbCustomClassNames } from "./ClassNames/classNames.dnb";
import { rdamCustomClassNames } from "./ClassNames/classNames.rdam";
import { whitelabelCustomClassNames } from "./ClassNames/classNames.whitelabel";
import { getConfig } from "./featureSwitch";
const classNamesConfigs = {
    vbp: defaultClassNames,
    aanzet: aanzetCustomClassNames,
    bkw: whitelabelCustomClassNames,
    dnb: dnbCustomClassNames,
    flevo: whitelabelCustomClassNames,
    rdam: rdamCustomClassNames,
    twente: whitelabelCustomClassNames
};
export const classNamesConfig = getConfig(classNamesConfigs);
